import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getSizeFilterConfig } from '../filters/size';
import { getConditionsFilterConfig } from '../filters/condition';
import { BuilderSections } from '../../util/builder';

const hammittSizes: string[] = [];

const handleHammittCustomCreditDescription = (data: { bundle: { displayId: string } }) => {
  const { displayId } = data.bundle;

  return `Payout for Treet Order #${displayId}`;
};

export const hammittShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({
      sizes: hammittSizes,
    }),
  ],
  builderConfig: {
    sections: {
      // Builder Sections for About Page - currently not used
      [BuilderSections.AboutPageHeroContent]: '0ba5358a47fc41659c684fbc19196897',
      // [BuilderSections.AboutPageNavbarContent]: 'b7584445fa334ba5a8eb26e0c0880593',
      // [BuilderSections.AboutPageInfoTabContent]: '978272ec096d44f88fcb196745d632c9',
      [BuilderSections.LandingPageContent]: '853fe79fcafd400cb77b7542cb1281f4',
      [BuilderSections.TopbarContent]: 'cdafc6aaa42e465bb1702feb4edb8e65',
      [BuilderSections.ListingCardDetails]: '95bc6f4163e4497abae75bcfb8033a69',
      [BuilderSections.TopbarMobileContent]: '7942e0c9b8fe42d2925efcac6ab75284',
    },
  },
  additionalPayoutSettings: {
    buildCustomCreditDescription: handleHammittCustomCreditDescription,
  },
};
